import type { AdaptedExtra } from './adaptExtras';

export function compareExtras(a: AdaptedExtra, b: AdaptedExtra): number {
  const priorityA = a.priority ?? Infinity;
  const priorityB = b.priority ?? Infinity;
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }

  const featuredDiff = (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
  if (featuredDiff !== 0) {
    return featuredDiff;
  }

  const nameDiff = a.name.localeCompare(b.name);
  if (nameDiff !== 0) {
    return nameDiff;
  }

  return String(a.id).localeCompare(String(b.id), undefined, { numeric: true });
}
